module.exports = __webpack_public_path__ + "static/media/韓式燒肉便當.b7033283.jpg";